{
 "badge": {
  "id": "hud.badge",
  "x": 892,
  "y": 9,
  "w": 39,
  "h": 38
 },
 "credits": {
  "digits": {
   "x": 741,
   "y": 31,
   "w": 33,
   "h": 23
  },
  "sample": "20"
 },
 "bellCount": {
  "digit": {
   "x": 906,
   "y": 20,
   "w": 10,
   "h": 15
  },
  "sample": "3"
 }
}